module.exports = __webpack_public_path__ + "static/media/honor.12836fff.png";